const ceos = {
  slug: 'ceos',
  getCeos: () => `${ceos.slug}`,
  vote: () => `${ceos.slug}/vote`
}

export default ceos
